export interface BeaconDef {
  id: string;
  label: string;
  x: number;
  y: number;
  authorityId: string;
  isPort: boolean;
}

export const beaconDefs: BeaconDef[] = [
  { id: 'escrow', label: 'EscrowHubs', x: 0.3, y: 0.3, authorityId: 'escrowhubs', isPort: true },
  { id: 'naija', label: 'NaijaLancers', x: 0.7, y: 0.3, authorityId: 'naijalancers', isPort: true },
  { id: 'oracle', label: 'Oracle', x: 0.5, y: 0.5, authorityId: 'oracle', isPort: false },
  { id: 'minipay', label: 'MiniPay', x: 0.2, y: 0.7, authorityId: 'minipay', isPort: false },
  { id: 'quidax', label: 'Quidax', x: 0.8, y: 0.7, authorityId: 'quidax', isPort: false },
  { id: 'gate', label: 'Gatekeeper', x: 0.5, y: 0.8, authorityId: 'gatekeeper', isPort: false },
];
